import type { ReactNode } from "react";
import { Grid, Typography } from "@mui/material";
import type { GridProps } from "@mui/material";
import HasCompetenceIcon from "./HasCompetenceIcon";
import { porteesUtil } from "utils";
import type { BaseTransfert } from "models";
import { grey } from "@mui/material/colors";

interface PorteeAccordionDetailWithIconProps extends GridProps {
  isPorteeAdheree: boolean;
  transfert: string | BaseTransfert;
}

function PorteeAccordionDetailWithIcon({
  isPorteeAdheree,
  transfert,
  ...gridProps
}: Readonly<PorteeAccordionDetailWithIconProps>): ReactNode {
  return (
    <Grid container alignItems="center" spacing={1} {...gridProps}>
      <Grid size="auto">
        <HasCompetenceIcon checked={isPorteeAdheree} />
      </Grid>
      <Grid size="grow">
        <Typography color={isPorteeAdheree ? undefined : grey[400]} component="span">
          {porteesUtil.getPorteeLabel(transfert)}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default PorteeAccordionDetailWithIcon;
